import React, { useContext, useEffect, useState } from 'react';
import { Form, FormGroup, Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { RiRefreshLine, RiMailLine, RiLockPasswordLine } from "react-icons/ri";
import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri';


// Firebase & Context
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../../firebase';
import api from '../../api';
import { AuthContext } from '../../context/authContext';
import { Datacontext } from '../../context/dataContext';

// Assets & CSS
import logo from '../Photos/logo.svg';
import '../css/others/Login.css';

const Login = () => {
    const { setUser } = useContext(AuthContext);
    const { initData } = useContext(Datacontext);
    const navigate = useNavigate();

    // Captcha State
    const [captchaQuestion, setCaptchaQuestion] = useState({ num1: 0, num2: 0, answer: 0 });
    const [captchaInput, setCaptchaInput] = useState("");
    const [captchaAnswer, setCaptchaAnswer] = useState("");

    // Generate new math captcha
    const generateCaptcha = () => {
        const num1 = Math.floor(Math.random() * 10) + 1;
        const num2 = Math.floor(Math.random() * 10) + 1;
        const answer = num1 + num2;
        setCaptchaQuestion({ num1, num2, answer });
        setCaptchaInput("");
        setCaptchaAnswer("");
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    // Validate captcha answer in real-time
    useEffect(() => {
        const userAnswer = parseInt(captchaInput);
        if (!isNaN(userAnswer) && userAnswer === captchaQuestion.answer) {
            setCaptchaAnswer("valid");
        } else {
            setCaptchaAnswer("");
        }
    }, [captchaInput, captchaQuestion]);

    const showToast = (msg) =>
        toast.warn(msg, {
            position: "bottom-center",
            autoClose: 3000,
            theme: "dark",
            transition: Zoom,
        });

    const handleLogin = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        
        const loginCard = document.querySelector('.login-main-card');

        try {
            if (!/^[a-z0-9/@.]+$/.test(data.usermail.trim())) {
                throw new Error("Invalid format");
            }

            if (captchaAnswer !== "valid") {
                return showToast("Please solve the math captcha correctly");
            }

            const email = data.usermail.trim();
            const password = data.passwordd.trim();

            const result = await signInWithEmailAndPassword(auth, email, password);
            //await signInWithEmailAndPassword(authStore, email, password);
            const token = await result.user.getIdToken();
            sessionStorage.setItem("token", token);

            const log = await api.get('/login');
            const userData = log.data.userData;
            
            setUser(userData);
            sessionStorage.setItem("user", JSON.stringify(userData));
            await initData();
            navigate('/dashboard');

        } catch (error) {
            // Trigger Shake Animation
            console.log(error)
            loginCard.classList.add('shake-error');
            setTimeout(() => loginCard.classList.remove('shake-error'), 500);

            if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
                showToast("Invalid Credentials");
            } else {
                showToast(error.response?.data?.message || "Login Failed. Try again.");
            }
            generateCaptcha();
        }
    };

    const [showPassword, setShowPassword] = useState(false);

  // 2. Toggle function
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

    return (
        <div className="login-page-wrapper">
            <ToastContainer />
            <Container>
                <Row className="justify-content-center">
                    <Col md={10} lg={9} className="login-main-card shadow-lg p-0 overflow-hidden">
                        <Row className="g-0">
                            
                            {/* Left Side: Branding */}
                            <Col md={5} className="login-visual-section d-none d-md-flex flex-column justify-content-center align-items-center text-center">
                                <div className="glass-overlay"></div>
                                <img src={logo} alt='logo' className=' mb-3' />
                                {/*<h2 className="text-white fw-bold">THIRUPATHI</h2>
                                <p className="text-white-50 px-4">Documentation & Management System</p>*/}
                            </Col>

                            <Col md={5} className="login-visual-section1 d-block d-md-none flex-column justify-content-center align-items-center text-center">
                                <div className="glass-overlay"></div>
                                <img src={logo} alt='logo' className=' mb-3' style={{width:"400px",height:"150px"}} />
                                {/*<h2 className="text-white fw-bold">THIRUPATHI</h2>
                                <p className="text-white-50 px-4">Documentation & Management System</p>*/}
                            </Col>

                            {/* Right Side: Form */}
                            <Col md={7} className="login-form-section bg-white p-4 p-lg-5">
                                <div className="mb-4">
                                    <h3 className="fw-bold color-purple">Login</h3>
                                    <p className="text-muted small">Access your dashboard with your credentials</p>
                                </div>

                                <Form onSubmit={handleLogin}>
                                    <FormGroup className="mb-3">
                                        <Form.Label className="label-sm">USER MAIL ID</Form.Label>
                                        <div className="modern-input-group">
                                            <RiMailLine className="input-icon" />
                                            <Form.Control 
                                                type='email' 
                                                name='usermail' 
                                                placeholder='Enter your email' 
                                                required 
                                            />
                                        </div>
                                    </FormGroup>

                                    <FormGroup className="mb-4">
      <Form.Label className="label-sm">PASSWORD</Form.Label>
      <div className="modern-input-group" style={{ position: 'relative' }}>
        <RiLockPasswordLine className="input-icon" />
        
        <Form.Control 
          // 3. Change type dynamically based on state
          type={showPassword ? 'text' : 'password'} 
          name='passwordd' 
          placeholder='Enter password' 
          required 
          style={{ paddingRight: '40px' }} // Make room for the eye icon
        />

        {/* 4. The Toggle Icon */}
        <div 
          onClick={togglePasswordVisibility}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
        </div>
      </div>
    </FormGroup>

                                    <div className="captcha-container mb-4">
                                        <Form.Label className="label-sm text-primary fw-bold">SECURITY CHECK</Form.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="captcha-question">
                                                {captchaQuestion.num1} + {captchaQuestion.num2} = ?
                                            </div>
                                            <Form.Control 
                                                type='number' 
                                                className="captcha-input" 
                                                value={captchaInput}
                                                onChange={(e) => setCaptchaInput(e.target.value)}
                                                placeholder="Ans"
                                                required
                                            />
                                            <button type="button" className="refresh-btn" onClick={generateCaptcha}>
                                                <RiRefreshLine />
                                            </button>
                                        </div>
                                        {captchaAnswer === "valid" && <small className="text-success mt-1 d-block">✓ Verified</small>}
                                    </div>

                                    <Button 
                                        disabled={captchaAnswer !== "valid"} 
                                        className={`w-100 py-2 modern-submit-btn ${captchaAnswer === "valid" ? 'btn-ready' : ''}`} 
                                        type='submit'
                                    >
                                        {captchaAnswer === "valid" ? 'SIGN IN' : 'SOLVE CAPTCHA'}
                                    </Button>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Login;